import { render } from "./community.vue?vue&type=template&id=52595fbf&scoped=true"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"

import "./community.vue?vue&type=style&index=0&id=52595fbf&scoped=true&lang=css"
import "./community.vue?vue&type=style&index=1&id=52595fbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52595fbf"]])

export default __exports__